import { CalendarIcon } from "assets/icons";
import cn from "classnames";
import DatePicker from "react-date-picker";
import { Value } from "react-date-picker/dist/cjs/shared/types";
import { FormField } from "ui/FormField";

import { DateInputProps } from "./DateInput.types";

import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "./DateInputClear.scss";
import styles from "./DateInput.module.scss";

const DateInput = ({
  label,
  errorMessage,
  errorWithoutMessage,
  action = null,
  onChange,
  value,
  calendarIcon,
  ...props
}: DateInputProps) => {
  const handleInputChange = (nextValue: Value) => {
    if (!onChange || !nextValue) {
      return;
    }

    if (Array.isArray(nextValue) && nextValue.length > 0 && nextValue[0]) {
      onChange(nextValue[0]);
    } else {
      onChange(nextValue as Date);
    }
  };

  return (
    <FormField label={label} errorMessage={errorMessage}>
      <div className={styles.dateInput__wrapper}>
        <DatePicker
          value={value}
          className={cn(styles.dateInput, {
            [styles.dateInput__error]: !!errorMessage || errorWithoutMessage
          })}
          onChange={handleInputChange}
          calendarIcon={calendarIcon ?? <CalendarIcon color="#FB3973" />}
          clearIcon={null}
          locale={"en"}
          format="dd/MM/yyyy"
          calendarProps={{ className: "calendar" }}
          {...props}
        />

        {action}
      </div>
    </FormField>
  );
};

export default DateInput;
